export const SET_TITLE = 'SET_TITLE';
export const CLEAR_STATE = 'CLEAR_STATE';
export const GETTING_TOKEN = 'GETTING_TOKEN';
export const SET_AUTHED = 'SET_AUTHED';
export const SET_AUTHENTICATING = "SET_AUTHENTICATING";
export const SET_CONNECTED = 'SET_CONNECTED'
export const SET_STORE_VERSION = 'SET_STORE_VERSION';
export const SET_MODAL = 'SET_MODAL';
export const RESET_MODAL = 'RESET_MODAL';

export const SAVE_USER = 'SAVE_USER';
export const SET_USER = 'SET_USER';
export const REMOVE_USER = 'REMOVE_USER';
export const ADD_PRACTICE_TO_USER = 'ADD_PRACTICE_TO_USER';
export const INSERT_USER = 'INSERT_USER';

export const SET_USER_ACCOUNT_EXISTS_CREDS = 'SET_USER_ACCOUNT_EXISTS_CREDS';
export const ADMIN_SAVE_USER = 'ADMIN_SAVE_USER';
export const ADMIN_SET_USER = 'ADMIN_SET_USER';
export const ADMIN_SET_USERS = 'ADMIN_SET_USERS';
export const ADMIN_FETCH_USERS = 'ADMIN_FETCH_USERS';

export const INSERT_PATIENT = "INSERT_PATIENT";
export const UPDATE_PATIENT = "UPDATE_PATIENT";
export const SET_PATIENTS = "SET_PATIENTS";
export const SET_PATIENT = "SET_PATIENT";
export const REMOVE_PATIENT = "REMOVE_PATIENT";

export const INSERT_TOAST = "INSERT_TOAST";
export const SET_TOASTS = "SET_TOASTS";
export const REMOVE_TOAST = "REMOVE_TOAST";
export const REMOVE_TOAST_BY_INDEX = "REMOVE_TOAST_BY_INDEX";

export const SET_SESSIONS = "SET_SESSIONS";
export const INSERT_SESSIONS = "INSERT_SESSIONS";

export const SET_SESSION_COMMENTS = "SET_SESSION_COMMENTS";
export const REMOVE_SESSION_COMMENT = "REMOVE_SESSION_COMMENT";
export const INSERT_SESSION_COMMENT = "INSERT_SESSION_COMMENT";
export const INSERT_SESSION_USER = "INSERT_SESSION_USER"
export const INSERT_SESSION_USERS = "INSERT_SESSION_USERS"

export const INSERT_SESSION = "INSERT_SESSION";
export const REMOVE_SESSION = "REMOVE_SESSION";
export const SET_SESSION = "SET_SESSION";
export const TOGGLE_SESSION_VIDEO_DONE= "TOGGLE_SESSION_VIDEO_DONE"

export const UPDATE_SESSION_NOTIFICATION = "UPDATE_SESSION_NOTIFICATION"

export const SET_PATIENT_RECORD = "SET_PATIENT_RECORD";
export const SET_PATIENT_RECORDS = "SET_PATIENT_RECORDS"
export const INSERT_PATIENT_RECORD = "INSERT_PATIENT_RECORD"

export const INSERT_ASSESSMENT = "INSERT_ASSESSMENT";
export const SET_ASSESSMENTS = "SET_ASSESSMENTS"
export const SET_ASSESSMENT = "SET_ASSESSMENT"

export const SET_PRACTICES = "SET_PRACTICES";
export const SET_APP_PRACTICE = "SET_APP_PRACTICE";
export const SET_APP_PRACTICE_FIELD = "SET_APP_PRACTICE_FIELD";
export const SET_APP_PRACTICE_LOGO = "SET_APP_PRACTICE_LOGO"
export const DELETE_PRACTICE = "DELETE_PRACTICE"
export const UPDATE_PRACTICE = 'UPDATE_PRACTICE';
export const SET_PRACTICE = "SET_PRACTICE";
export const FETCH_PRACTICE = 'FETCH_PRACTICE';

export const SET_PRACTICE_TYPES = 'SET_PRACTICE_TYPES';
export const INSERT_PRACTICE_TYPE = 'INSERT_PRACTICE_TYPE';
export const DELETE_PRACTICE_TYPE = 'DELETE_PRACTICE_TYPE';
export const UPDATE_PRACTICE_TYPE = 'UPDATE_PRACTICE_TYPE';

export const ADD_USER_TO_PRACTICE = 'ADD_USER_TO_PRACTICE';
export const SET_APP_PRACTICE_PENDING_USERS = 'SET_APP_PRACTICE_PENDING_USERS';
export const SET_APP_PRACTICE_PARENTS = 'SET_APP_PRACTICE_PARENTS';
export const SET_APP_PRACTICE_THERAPISTS = 'SET_APP_PRACTICE_THERAPISTS';
export const SET_APP_PRACTICE_AVAILABLE_PATIENTS = 'SET_APP_PRACTICE_AVAILABLE_PATIENTS';
export const REMOVE_APP_PRACTICE_AVAILABLE_PATIENT = 'REMOVE_APP_PRACTICE_AVAILABLE_PATIENT';

export const SET_APP_FIELD = "SET_APP_FIELD";

export const SET_THERAPY_AREAS = 'SET_THERAPY_AREAS';
export const FETCH_THERAPY_AREAS = 'FETCH_THERAPY_AREAS';
export const SAVE_THERAPY_AREA = 'SAVE_THERAPY_AREA';
export const DELETE_THERAPY_AREA = 'DELETE_THERAPY_AREA';
export const INSERT_THERAPY_AREA = 'INSERT_THERAPY_AREA';
export const UPDATE_THERAPY_AREA = 'UPDATE_THERAPY_AREA';

export const SET_THERAPY_CATEGORIES = 'SET_THERAPY_CATEGORIES';
export const FETCH_THERAPY_CATEGORIES = 'FETCH_THERAPY_CATEGORIES';
export const SAVE_THERAPY_CATEGORY = 'SAVE_THERAPY_CATEGORY';
export const DELETE_THERAPY_CATEGORY = 'DELETE_THERAPY_CATEGORY';
export const INSERT_THERAPY_CATEGORY = 'INSERT_THERAPY_CATEGORY';
export const UPDATE_THERAPY_CATEGORY = 'UPDATE_THERAPY_CATEGORY';

export const ADMIN_TOGGLE_VIDEO_THERAPY_AREA = 'ADMIN_TOGGLE_VIDEO_THERAPY_AREA';

export const SET_VIDEOS = 'SET_VIDEOS';
export const FETCH_VIDEOS = 'FETCH_VIDEOS';
export const SAVE_VIDEO = 'SAVE_VIDEO';
export const DELETE_VIDEO = 'DELETE_VIDEO';
export const INSERT_VIDEO = 'INSERT_VIDEO';
export const UPDATE_VIDEO = 'UPDATE_VIDEO';

export const UPDATE_USER_TERMS_CONDITIONS = 'UPDATE_USER_TERMS_CONDITIONS';


// Media Upload Constants
export const RESET_MEDIA_UPLOAD_STATE = 'RESET_MEDIA_UPLOAD_STATE';
export const SHOW_HIDE_MEDIA_UPLOAD = 'SHOW_HIDE_MEDIA_UPLOAD';
export const SET_VISIBLE_UPLOAD_COMPONENT = 'SET_VISIBLE_UPLOAD_COMPONENT';
export const SET_CURRENT_SESSION = 'SET_CURRENT_SESSION';
export const SET_IS_SESSION = 'SET_IS_SESSION';
export const SET_IS_INTERNAL_UPLOAD = 'SET_IS_INTERNAL_UPLOAD';
export const SET_SESSION_NAME = 'SET_SESSION_NAME';
export const SET_UPLOAD_PATH = 'SET_UPLOAD_PATH';
export const SET_UPLOADED_IMAGE = 'SET_UPLOADED_IMAGE';
export const SET_UPLOADED_DOCUMENT = 'SET_UPLOADED_DOCUMENT';
export const SET_VIDEO_CURRENTLY_UPLOADING = 'SET_VIDEO_CURRENTLY_UPLOADING';
export const SET_SCOPE_AND_SESSION_TYPE = 'SET_SCOPE_AND_SESSION_TYPE';
export const SET_CURRENT_PATIENT_IN_SESSION = 'SET_CURRENT_PATIENT_IN_SESSION';


// Gallery
export const RESET_GALLERY_STATE = 'RESET_GALLERY_STATE'
export const SET_GALLERY_ITEMS_FOR_PATIENT = 'GET_GALLERY_ITEMS_FOR_PATIENT'
export const SET_GALLERY_BY_ID = 'GET_GALLERY_BY_ID'
export const SET_VIDEO_UPLOAD_PERCENTAGE = 'GET_VIDEO_UPLOAD_PERCENTAGE'
// export const CREATE_GALLERY = 'CREATE_GALLERY'
// export const DELETE_GALLERY = 'DELETE_GALLERY'
// export const CREATE_GALLERY_VIDEO = 'CREATE_GALLERY_VIDEO'
// export const UPDATE_GALLERY_VIDEO = 'UPDATE_GALLERY_VIDEO'
// export const DELETE_GALLERY_VIDEO = 'DELETE_GALLERY_VIDEO'


// WEBPACK FOOTER //
// ./src/constants/ActionTypes.js